<template>
	<div >
		<div id="cloudCenter">
			<heads></heads>	
		</div>
		<div class='model' id="domId" style="width:100%; height:85%"></div>
	</div>
</template>

<script>
import { mapState,mapMutations} from 'vuex'
import heads from "@/components/header.vue"
export default {
  data() {
    return {
      datadetails:{},	
      loading: false,
      viewToken: '2a618f105f4f4038aae6e7b2d04b276e',//模型生长：https://bimface.com/developer-jsdemo#1108
      viewer3D:'',
      app:'',
      sectionPlane : null,
      originPt : { x: 0, y: 0, z: 7600 },
      planeDirection : { x: 0, y: 0, z: 1 },
      sectionPlaneOffset : 500,
      isSectionPlaneAnimationActivated : false,
      animationId : null,
      drawableContainer:null,
      monitorName:'',
      unit:''
    }
  },
  watch:{
  	addlable(data){
  		if(this.drawableContainer){
  			this.drawableContainer.clear();
  		}
		this.getDetails(data.data)
		
  	}
  },
  created(){   	
  },
  computed: {
			...mapState(['addlable']),
		},
  components: {
			heads,
		},
  mounted() {
		this.resetScreenSize()
       // 初始化显示组件
       var options = new BimfaceSDKLoaderConfig();
       options.viewToken = this.viewToken;
       BimfaceSDKLoader.load(options, this.successCallback, this.failureCallback);

      
  },
  methods: {
  	getDetails(id){
  		this.postAxios('/build/monitorPointAlert/selectById/'+id).then(res => {
  				let monintor
				this.datadetails=res.data.data
				//获取类型
				this.getAxios('adminDict/data/type/b_equipment_monitor_type').then(data => {
					monintor=data.data.data
					for(let i=0;i<monintor.length;i++){
						if(this.datadetails.monitorType==monintor[i].dictValue){
							this.monitorName=monintor[i].dictLabel
						}
					}
				}).catch(err => {})
				//获取坐标
				this.postAxios('/build/equipmentMonitorPoint/getById/'+this.datadetails.monitorPointId).then(data => {
					this.unit=data.data.data.unit
					var worldPositions = {}
					var m = data.data.data.controlsCoordinates
		            if (m != null && m != '') {
		              m = data.data.data.controlsCoordinates.split(',')
		              if (m.length > 2) {
		                worldPositions = { 'x': m[0], 'y': m[1], 'z': m[2] }
		              }
		            }
		            console.log(worldPositions)
					 this.addlabel(worldPositions)
					  //this.addlabel({"x": 8777.727595227247, "y": -4610.087541747591, "z": 7008.466080953338})
				}).catch(err => {})
				
			}).catch(err => {})
  	},
  	resetScreenSize(dw, dh) {
				if(window.innerWidth > 1000) {
					function init() {
						var _el = document.getElementById('cloudCenter');
						var hScale = window.innerHeight / (dh || 1080);
						var wScale = window.innerWidth / (dw || 1920);
						_el.style.transform = 'scaleX(' + wScale + ') scaleY(' + hScale + ')'
					}
					var lazyFun;
					window.onresize = function() {
						clearTimeout(lazyFun);
						lazyFun = setTimeout(function() {
							init()
						}, 600)
					}
					init()
				}
			},
    createSectionPlane(){
      if (!this.viewAdded || this.sectionPlane) {
        return;
      }
      var sectionPlaneConfig = new Glodon.Bimface.Plugins.Section.SectionPlaneConfig();
      sectionPlaneConfig.viewer = this.viewer3D;
      this.sectionPlane = new Glodon.Bimface.Plugins.Section.SectionPlane(sectionPlaneConfig);
      this.sectionPlane.setPlane(Glodon.Bimface.Plugins.Section.SectionPlanePlane.Z);
      this.sectionPlane.setDirection(Glodon.Bimface.Plugins.Section.SectionPlaneDirection.Forward);
      this.sectionPlane.setPositionByPlane(this.originPt, this.planeDirection, this.sectionPlaneOffset);
      this.sectionPlane.setObjectsByObjectData([
        {
          categoryId: "-2000011",
          family: "基本墙"
        },
        {
          categoryId: "-2001330"
        }
      ]);
      this.sectionPlane.hidePlane();
      },
    sectionPlaneAnimation(){
      if (!this.viewAdded || !this.sectionPlane) {
        return;
      }
      if (!this.isSectionPlaneAnimationActivated) {
        this.animate();
        this.setButtonText('btnSctPlaneAnimation', '停止剖切动画');
      } else {
        this.cancelAnimationFrame(this.animationId);
        this.sectionPlaneOffset = 500;
        this.sectionPlane.setPositionByPlane(originPt, planeDirection, sectionPlaneOffset);
        this.viewer3D.render();
        this.setButtonText('btnSctPlaneAnimation', '开启剖切动画');
      }
      this.isSectionPlaneAnimationActivated = !this.isSectionPlaneAnimationActivated;
    },
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      this.sectionPlaneOffset += 50;
      if (this.sectionPlaneOffset > 3500) {
        this.sectionPlaneOffset = 500;
      }
      this.sectionPlane.setPositionByPlane(this.originPt, this.planeDirection, this.sectionPlaneOffset);
      this.viewer3D.render();
    },
    setButtonText(btnId, text) {
      var dom = document.getElementById(btnId);
      if (dom != null && dom.nodeName == "BUTTON") {
        dom.innerText = text;
      }
    },
    // 加载成功回调函数
    successCallback(viewMetaData) {
      var that=this
      var dom4Show = document.getElementById('domId');
      // 设置WebApplication3D的配置项
      var webAppConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
      webAppConfig.domElement = dom4Show;
      // 创建WebApplication3D，用以显示模型
      let app = new Glodon.Bimface.Application.WebApplication3D(webAppConfig);
      app.addView(that.viewToken);
      var viewer3D = app.getViewer();
      that.viewer3D = viewer3D;
      if(that.$route.params.id){
      	that.getDetails(this.$route.params.id)
  		}
      //点击
//    that.viewer3D.addEventListener(Glodon.Bimface.Application.WebApplication3DEvent.ComponentsSelectionChanged, function(componentData) {
//        console.log(componentData)
//        if (componentData && componentData.objectId) {
//          console.log(componentData.worldPosition)
//          if( that.drawableContainer){
//          	
//          	that.drawableContainer.clear();
//          }
//          that.addlabel(componentData.worldPosition)
//        } else {
//          alert('123321')
//        }
//      })
      // 增加加载完成监听事件
      that.viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.ViewAdded, function () {
        that.viewAdded = true;
        //自适应屏幕大小
        window.onresize = function () {
          that.viewer3D.resize(document.documentElement.clientWidth, document.documentElement.clientHeight - 40);
        }
        
        
		
        //设置背景颜色
        that.viewer3D.setBackgroundColor(new Glodon.Web.Graphics.Color(105, 105, 105, 0));
        
        that.viewer3D.setCameraStatus({
          "name": "persp",
          "position": { "x": -30219.946765163415, "y": -45491.65416486451, "z": 29660.465140231066 },
          "target": { "x": 207832.38340026487, "y": 170233.69288006236, "z": -126343.72635548069 },
          "up": { "x": 0.3236896665312058, "y": 0.2933266544203183, "z": 0.8995468156730366 },
          "fov": 45,
          "zoom": 1,
          "version": 1,
          "coordinateSystem": "world"
        });
        that.viewer3D.hideComponentsByObjectData([
          {
            levelName: "Roof"
          },
          {
            levelName: "Parapet"
          },
          {
            levelName: "03 - Floor",
            categoryId: "-2000038"
          },
          {
            categoryId: "-2000023"
          }
        ]);
        that.createSectionPlane();
        // 渲染场景
        that.viewer3D.render();
        
        
      });
    },
    // 加载失败回调函数
    failureCallback(error) {
      console.log(error);
    },
    //添加自定义标签
     addlabel(posi,data){
     	let that=this
     	
	        var position = new Object();
	        position = posi;
	         // 初始化DrawableContainer
	        var drawableConfig = new Glodon.Bimface.Plugins.Drawable.DrawableContainerConfig();
	        drawableConfig.viewer = that.viewer3D;
	        that.drawableContainer = new Glodon.Bimface.Plugins.Drawable.DrawableContainer(drawableConfig);
	         // 创建自定义元素，可以是一个dom element，也可以是个字符串
	        var config = new Glodon.Bimface.Plugins.Drawable.CustomItemConfig();
	        var content = document.createElement('div');
	        content.innerHTML = `<div class="leadTips">
						        <div style="float: left;" style="width:49px;height:35px;">
						        <img  src="https://static.bimface.com/attach/24ce9654e88a4218908f46279e5c4b04_line.png" height="35" width="49"/></div>
						        <div class="leadText" >
						        	<div class="models">报警类型:<span>${that.monitorName}</span></div>
						        	<div class="models">报警位置:<span>${that.datadetails.locationName}</span></div>
						        	<div class="models">报警设备:<span>${that.datadetails.assetName}</span></div>
						        	<div class="models">报警内容:<span>${that.datadetails.content}</span></div>
						        	<div class="models">报警值:<span>${that.datadetails.monitorData}${that.unit}</span></div>
						        	<div class="models">报警时间:<span>${that.datadetails.createTime}</span></div>
						        </div>
						        </div>`
	        config.content = content;
	        config.viewer = that.viewer3D;
	        config.worldPosition = position;
	        //生成customItem实例
	        var customItem = new Glodon.Bimface.Plugins.Drawable.CustomItem(config);
	        // 添加自定义标签
	        that.drawableContainer.addItem(customItem);
        }
  }
}
</script>

<style scoped>
#cloudCenter {
		width: 1920px;
		height: 1080px;
		transform-origin: left top;
		position: relative;
	}
.leadText{
	height: 200px;
	width: 200px;
	background: red;
}
.model{
	position: absolute;
	top: 100px;
}
 /deep/.leadTips {
      display: flex;
      justify-content: flex-start;
      width: auto;
      transform: translateY(-40px)
    }
/deep/.leadTips img {
      display: inline-block;
      width: 49px;
      height: 40px
    }    
/deep/.leadText{
	padding: 20px;
	color: #FFFFFF;
	float: left;
	background: rgba(0,0,0,0.7);
	border:10px solid skyblue;
	
}
/deep/.models{
	margin-bottom: 10px;
	width: 300px;
	height: 30px;
	line-height: 30px;
	font-size: 14px;
	border-bottom: 1px solid #C0C4CC;
}
/deep/.model span{
	margin-left: 10px;
}
</style>

